import { ClearingDepositInstrumentType as Type } from '../../types/gql';
import { BankInstrumentId, BankInstrumentComponents } from './types';
import { USDOnline } from './components/USDOnline';
import { USDOffline } from './components/USDOffline';
import { RUBOffline } from './components/RUBOffline';
import { makeIds } from '../../utils/instrumentId';

export const supports = [
  ...makeIds(Type.OnlineBankTransfer, ['USD']),
  ...makeIds(Type.OfflineBankTransfer, ['USD', 'RUB']),
] as const;

export const subSchema: Record<BankInstrumentId, BankInstrumentComponents> = {
  ONLINE_BANK_TRANSFER_USD: USDOnline,
  OFFLINE_BANK_TRANSFER_RUB: USDOffline,
  OFFLINE_BANK_TRANSFER_USD: RUBOffline,
};
